import { observer } from 'mobx-react-lite'
import React from 'react'
import { MDBCol, MDBRow } from 'mdbreact'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import SubscriptionsStore from './../../Subscriptions.store'

const StripeDetails = () => {
  // if (!UserProfileService.isA(['agency-owner','internal-admin','internal-staff','system-admin'], true))
  //   return <></>

  const { subscriptionId, customerId, subSource } = SubscriptionsStore

  return (
    <>
      <MDBRow>
        <MDBCol size="12" md="6" className="mt-1">
          <strong>Merchant:</strong> {subSource?.merchant || 'N/A'}
        </MDBCol>
        <MDBCol size="12" md="6" className="mt-1">
          <strong>Amount:</strong> {subSource?.amount || 'N/A'}
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol size="12" md="6" className="mt-1">
          <strong>Customer ID:</strong> {customerId || 'N/A'}
        </MDBCol>
        <MDBCol size="12" md="6" className="mt-1">
          <strong>Subscription ID:</strong> {subscriptionId || 'N/A'}
        </MDBCol>
      </MDBRow>
    </>
  )
}

export default observer(StripeDetails)
